import React from 'react'
import classNames from 'classnames'

import './Table.scss'

/**
 * @import import { Table } from '@/components/tables/Table/Table'
 * @param {object} props
 * @param {boolean} [props.celled] Vertical borders between columns
 * @param {boolean} [props.compact] Tighter cell padding
 * @param {boolean} [props.plain] Removes the background, outer border, and row dividers
 * @param {boolean} [props.borderless] Removes the background and outer border but keeps row dividers and cell padding
 * @param {boolean} [props.striped] Alternating row background
 * @param {string} [props.className] Additional classes on the table element
 * @param {node} props.children Standard table markup (thead, tbody, tr, th, td)
 */
export const Table = ({
  celled,
  compact,
  plain,
  borderless,
  striped,
  className,
  children,
  ...props
}) => {
  return (
    <table
      className={classNames(
        'balto-table',
        { celled, compact, plain, borderless, striped },
        className
      )}
      {...props}
    >
      {children}
    </table>
  )
}
